import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvConfigurationService } from '../envconf.service';
import { MFAFactorRequestDTO, MFAFactorResponseDTO } from '../../models/mfa-factor.dto';
import { ResetPasswordRequestDTO } from '../../models/reset-password-request.dto';
import { UserApplicationDTO } from '../../models/user-application.dto';

export interface UserProfileDTO {
  reset_password?: boolean;
  appPermissions?: string[];
  [key: string]: unknown;
}

// Self-service do usuário logado no monólito (BACKEND_URL); o Bearer é injetado pelo authInterceptor.
@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly path = '/api/v1/me';
  private readonly authUserPath = '/v1/user';

  constructor(private http: HttpClient) {}

  private get baseUrl(): string {
    return `${EnvConfigurationService.configuration.BACKEND_URL}${this.path}`;
  }

  getMe(): Observable<UserProfileDTO> {
    return this.http.get<UserProfileDTO>(this.baseUrl);
  }

  getMfaFactors(): Observable<any> {
    return this.http.get<MFAFactorResponseDTO[]>(`${this.authUserUrl}/mfa-factors`);
  }

  createMfaFactor(body: MFAFactorRequestDTO): Observable<MFAFactorResponseDTO> {
    return this.http.post<MFAFactorResponseDTO>(`${this.authUserUrl}/mfa-factors`, body);
  }

  getMyApplications(): Observable<UserApplicationDTO[]> {
    return this.http.get<UserApplicationDTO[]>(`${this.authUserUrl}/me/applications`);
  }

  resetPassword(dto: ResetPasswordRequestDTO): Observable<void> {
    return this.http.put<void>(`${this.authUserUrl}/reset-password`, dto);
  }

  private get authUserUrl(): string {
    return `${EnvConfigurationService.configuration.AUTH_BACKEND_URL}${this.authUserPath}`;
  }
}
